import React from 'react'
import Helmet from 'react-helmet'
import _ from 'lodash'

const handleEndPath = () => {
  const currentLocation = window.location.pathname

  const pathArr = _.remove(currentLocation.split('/').splice(1), (path) => {
    return path !== 'uk'
  })
  let endPath = ''

  _.map(pathArr, (path, index) => {
    endPath = endPath + '/' + path
  })

  return endPath
}

const Metatags = (props) => {
  const image = props.image
    ? props.image
    : window.location.origin + '/512x512.png'

  return (
    <Helmet>
      <html
        lang={
          window.location.pathname.split('/')[1] === 'uk' ? 'en-GB' : 'en-US'
        }
      />
      {/* Canonical Tags START */}
      {window.location.origin + handleEndPath() ===
      'https://www.workforce.com/' ? (
          <link rel="canonical" href={'https://www.workforce.com'} />
        ) : (
          <link rel="canonical" href={window.location.origin + handleEndPath()} />
        )}

      {window.location.origin + handleEndPath() ===
      'https://www.workforce.com/' ? (
          <link
            rel="alternate"
            hrefLang="en-US"
            href={'https://www.workforce.com'}
          />
        ) : (
          <link
            rel="alternate"
            hrefLang="en-US"
            href={window.location.origin + handleEndPath()}
          />
        )}
      {window.location.origin + handleEndPath() ===
      'https://www.workforce.com/' ? (
          <link
            rel="alternate"
            hrefLang="en-GB"
            href={'https://www.workforce.com/uk'}
          />
        ) : (
          <link
            rel="alternate"
            hrefLang="en-GB"
            href={window.location.origin + '/uk' + handleEndPath()}
          />
        )}
      {/* Canonical Tags END */}
      <title>{props.title}</title>
      <meta name="description" content={props.description} />

      {/* OPEN GRAPH */}
      <meta property="og:type" content="business.business" />
      <meta
        property="og:locale"
        content={
          window.location.pathname.split('/')[1] === 'uk' ? 'en-GB' : 'en-US'
        }
      />
      <meta property="og:title" content={props.title} />
      <meta property="og:description" content={props.description} />
      <meta property="og:url" content={window.location.href} />
      <meta property="og:image" content={image} />
      <meta property="og:site_name" content="Workforce.com" />
      <meta property="fb:app_id" content="2454201338169116" />

      {/* BUSINESS */}
      <meta
        property="business:contact_data:street_address"
        content={
          window.location.pathname.split('/')[1] === 'uk'
            ? 'The Frames 1 Phipp Street'
            : '150 N. Michigan Ave. Floor 5'
        }
      />
      <meta
        property="business:contact_data:locality"
        content={
          window.location.pathname.split('/')[1] === 'uk'
            ? 'London'
            : 'Chicago, IL'
        }
      />
      <meta
        property="business:contact_data:postal_code"
        content={
          window.location.pathname.split('/')[1] === 'uk' ? 'EC2A 4PS' : '60601'
        }
      />
      <meta
        property="business:contact_data:country_name"
        content={
          window.location.pathname.split('/')[1] === 'uk'
            ? 'United Kingdom'
            : 'United States'
        }
      />

      {/* TWITTER */}
      <meta name="twitter:site" content="@workforcedotcom" />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={props.title} />
      <meta name="twitter:description" content={props.description} />
      <meta name="twitter:image" content={image} />
    </Helmet>
  )
}

export default Metatags
